module.exports = __webpack_public_path__ + "img/index.9c427ae2.png";